import React from "react";
export default class Confirmation extends React.Component {
    state = {

    }
    render() {
        return (
            <div className="w-100 h-100" style={{ backgroundColor: 'white', padding: ".3rem 1rem" }}>
                <div className="confirmation" style={{ width: "100%", height: "100%" }}>
                    <div className="confirmation-header flex">
                        {/* <img src="/assets/icons/portals/Asset 2.svg" className="prd-2" alt="" height="30" /> */}
                        Task Confirmation
                    </div>
                    <div className="" style={{ display: "flex", flexDirection: "column", justifyContent: "left", padding: "2rem 0rem", paddingBottom: "1rem" }}>
                        <div className="request-info  flex-1" style={{ display: "flex", flexDirection: "row", justifyContent: "left", padding: "1rem 1rem", marginBottom: ".5rem" }}>
                            <img src="/assets/icons/person.svg" className="confirmation-img mrd-2" />
                            <div>
                                <p className="confirmation-title">Applet</p>
                                {console.log('props', this.props.item)}
                                <p className="confirmation-text">Applet</p>
                            </div>
                        </div>
                        <div className="request-info  flex-1" style={{ display: "flex", flexDirection: "row", justifyContent: "left", padding: "1rem 1rem", marginBottom: ".5rem" }}>
                            <img src="/assets/icons/person.svg" className="confirmation-img mrd-2" />
                            <div>
                                <p className="confirmation-title">Hub</p>
                                {console.log('props', this.props.item)}
                                <p className="confirmation-text">{this.props.item.hub.username}</p>
                            </div>
                        </div>
                        <div className="request-info   flex-1" style={{ display: "flex", flexDirection: "row", justifyContent: "left", padding: "1rem 1rem" }}>
                            <img src="/assets/icons/gantt/today-tasks.svg" className="confirmation-img mrd-2" />
                            <div>
                                <p className="confirmation-title">Task</p>
                                <p className="confirmation-text">{this.props.item.task.title}</p>
                            </div>
                        </div>
                    </div>
                    <div className="flexcc py-1">
                        <input className="description" name="name" placeholder="Description ..." type="text" />
                    </div>
                    <div className="flexcc prd-2 pb-2" style={{ justifyContent: 'right', paddingRight: "2rem" }}>
                        <button onClick={() => this.props.approveTask(this.props.item, false)} className="confirmation-button">Decline</button>
                        <button onClick={() => this.props.approveTask(this.props.item, true)} className="confirmation-button">Accept</button>
                    </div>
                </div>
            </div>
        );
    }
}